import React from 'react';
import { IOption, Option, OptionCheck, OptionContent, OptionIconContainer, GrayCircle } from './index';
import { GreenCheckIcon } from 'assets/icons';
import partial from 'lodash-es/partial';
import styled from 'styled-components/macro';
import Tooltip from '../Tooltip';
import { Text } from '@televet/kibble-ui';

interface IDropdownOptions {
  tooltipContent: Record<string, string> | undefined;
  isDisabled: boolean | undefined;
  tooltipIsDisabled: boolean;
  isNested: boolean;
  option: IOption;
  isRowReversed: boolean;
  handleOptionClick: (option: IOption, e: React.MouseEvent<HTMLDivElement>) => void;
  handleKeyboardNavigation: (e: React.KeyboardEvent<HTMLDivElement>, elementIsInputField: boolean) => void;
  showActivityStatus: boolean | undefined;
  dropdownOptionRefs: React.MutableRefObject<HTMLDivElement[] | null[]>;
  isMultiSelect: boolean;
  index: number;
}

const DropdownOption = ({
  option,
  isDisabled,
  tooltipContent,
  isNested,
  isRowReversed,
  handleOptionClick,
  handleKeyboardNavigation,
  showActivityStatus,
  dropdownOptionRefs,
  isMultiSelect,
  index,
}: IDropdownOptions): JSX.Element => {
  return (
    <>
      <Tooltip content={tooltipContent} delay={isDisabled ? [300, 0] : [500, 0]} disabled={!isDisabled}>
        <Option
          tabIndex={1}
          isNested={isNested}
          onClick={partial(handleOptionClick, option)}
          isSelected={option.isSelected}
          isDisabled={isDisabled}
          isLabel={option.isLabel}
          isBold={option.isBold}
          data-disabled={isDisabled}
          isReverse={isRowReversed}
          ref={(el): HTMLDivElement | null => (dropdownOptionRefs.current[index] = el)}
          onKeyDown={(e): void => handleKeyboardNavigation(e, false)}
          data-testid={`dropdown-option-${index}`}
        >
          {!!isMultiSelect && (
            <OptionCheck tabIndex={0}>{!!option.isSelected ? <GreenCheckIcon /> : <GrayCircle />}</OptionCheck>
          )}
          <OptionContent>
            {showActivityStatus && (
              <>{isDisabled ? <ActivityCircle color="#da4167" /> : <ActivityCircle color="#5cc098" />}</>
            )}
            <Text size="sm" isTruncated>
              {option.text}
            </Text>
            {option?.icon && <OptionIconContainer>{option.icon}</OptionIconContainer>}
          </OptionContent>
        </Option>
      </Tooltip>
    </>
  );
};

export default DropdownOption;

const ActivityCircle = styled.div<{ color: string }>`
  width: 9px;
  height: 9px;
  border-radius: 20px;
  background-color: ${({ color }): string => color};
  margin-right: 5px;
`;
